import React from 'react';
import './Footer.css';

function Footer({ onPrivacyClick }) {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-description">
          <h2 className="footer-title">About Wordle 6 7</h2>
          <p className="footer-text">
            <strong>Wordle 6 7</strong> (also known as <strong>Six Seven Wordle</strong>) is a daily word puzzle game
            where you guess a 6-letter word in 7 tries. Inspired by the viral Wordle game, our version features
            streak tracking, hard mode, and a new puzzle every day. Play free online with no downloads required!
          </p>
          <p className="footer-keywords">
            <strong>Keywords:</strong> wordle 6 7, six seven wordle, 6 7 wordle game, wordle six seven,
            6 letter wordle, 7 guess wordle, daily word puzzle, free wordle game
          </p>
        </div>
        <button className="footer-link" onClick={onPrivacyClick}>
          Privacy Policy
        </button>
      </div>
    </footer>
  );
}

export default Footer;
